import { render, staticRenderFns } from "./ManageTraining.vue?vue&type=template&id=0ba115be&"
import script from "./ManageTraining.vue?vue&type=script&lang=js&"
export * from "./ManageTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports